/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReportLevel {
    Info = '0',
    Error = 1,
    Warning = 2,
}
